export default __webpack_public_path__ + "static/media/play.7b736b85.svg";